import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import reqwest from 'reqwest';
import swal from '@sweetalert/with-react';
import { faSave, faTimes } from '@fortawesome/pro-regular-svg-icons';
import settings from '../../../../settings';
import DataContainer from '../../../logic/dataContainer';
import Loader from '../../../components/Loader';
import Button from '../../../components/Button';
import HeaderbarButton from '../../../components/HeaderbarButton';
import UserContext from '../../../hooks/UserContext';
import ClinicForm from './ClinicForm';
import {
  SAVE_ERROR_TEXT,
  canEditClinics,
  reportClinicRequestError,
} from './clinicAccess';

class SupplynetworkClinicsDetail extends Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(new RegExp('/new'), '');

    this.state = {
      loading: false,
      positions: [],
    };
  }

  zipValidator = [
    {
      custom: async (value) => {
        // Input liefert ohne Eingabe null statt ''.
        if (!value) return true;
        return reqwest({
          method: 'GET',
          url: settings.supplynetwork.getCoordsToZip,
          data: {
            zip: value,
          },
        }).then((result) => {
          if (result === 'No Data') return false;
          const coords = new DataContainer([JSON.parse(result)]);
          this.form.dataContainer.set(
            'ClinicData',
            'ZipLat',
          )(coords.get('Coordinates', 'ZipLat'));
          this.form.dataContainer.set(
            'ClinicData',
            'ZipLon',
          )(coords.get('Coordinates', 'ZipLon'));
          return true;
        });
      },
      error: 'Diese PLZ existiert nicht.',
    },
  ];

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Fehler bei Ihren Eingaben',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
      });
      return;
    }

    const data = this.form.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.supplynetwork.clinics.save,
      data: {
        Token: localStorage.getItem('token'),
        ClinicsAdress: data,
      },
    })
      .then(() => {
        swal({
          title: 'Gespeichert!',
          text: 'Die Adresse wurde erfolgreich gespeichert.',
          icon: 'success',
        });
        this.props.history.replace(this.parentRoute);
      })
      .catch((error) => {
        reportClinicRequestError(
          error,
          'Speichern fehlgeschlagen!',
          SAVE_ERROR_TEXT,
        );
      });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            Versorgungsnetzwerk -{' '}
            <Link to="/supplynetwork/Clinics">Klinken</Link> - <b>Neu</b>
          </div>
          <div className="Headerbar-buttons">
            <HeaderbarButton icon={faTimes} to={this.parentRoute}>
              Abbrechen
            </HeaderbarButton>
          </div>
        </div>
        <div className="Page-Content">
          <div className="Buttonbar">
            <UserContext.Consumer>
              {(context) =>
                canEditClinics(context) ? (
                  <>
                    <Button type="primary" icon={faSave} onClick={this.save}>
                      Speichern
                    </Button>
                  </>
                ) : null
              }
            </UserContext.Consumer>
          </div>
          <ClinicForm
            ref={(node) => {
              this.form = node;
            }}
            zipValidator={this.zipValidator}
          />
        </div>
      </>
    );
  }
}

export default SupplynetworkClinicsDetail;
